import React, {
  useEffect,
} from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import {
  useTranslation,
} from 'react-i18next';

import LoginSection
  from '../components/LoginSection';

import {
  useAuth,
} from '../AuthContext';

import {
  ROUTES,
} from '../../../config/routes';

import './LoginPage.css';

export default function LoginPage() {
  const {
    t,
    i18n,
  } = useTranslation(
    'common',
  );

  const {
    signIn,
  } = useAuth();

  const navigate =
    useNavigate();

  useEffect(
    () => {
      document.title =
        t(
          'meta.title',
        );
    },
    [
      t,
      i18n.resolvedLanguage,
    ],
  );

  const handleLoginSuccess =
    async () => {
      navigate(
        ROUTES.root,
        {
          replace: true,
        },
      );
    };

  const handleSignup =
    () => {
      navigate(
        ROUTES.signup,
      );
    };

  return (
    <main
      className="login-page"
    >
      <LoginSection
        loginAction={
          signIn
        }
        onLoginSuccess={
          handleLoginSuccess
        }
      />

      <button
        type="button"
        className="login-page-signup-button"
        onClick={
          handleSignup
        }
      >
        {t(
          'signup.title',
          {
            ns: 'app',
          },
        )}
      </button>
    </main>
  );
}